import { render, staticRenderFns } from "./ElementChoiceConfig.vue?vue&type=template&id=67929f32&"
import script from "./ElementChoiceConfig.vue?vue&type=script&lang=js&"
export * from "./ElementChoiceConfig.vue?vue&type=script&lang=js&"
import style0 from "./ElementChoiceConfig.vue?vue&type=style&index=0&id=67929f32&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67929f32')) {
      api.createRecord('67929f32', component.options)
    } else {
      api.reload('67929f32', component.options)
    }
    module.hot.accept("./ElementChoiceConfig.vue?vue&type=template&id=67929f32&", function () {
      api.rerender('67929f32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/contents/survey-paper-manage/ElementChoiceConfig.vue"
export default component.exports